import {createContext} from 'react'

const ArrowContext = createContext<Record<string, string>>({})
export default ArrowContext
